import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
const RunValidationCheckTable = ({ data }) => {
  return (
    <div
      style={{ overflowY: "auto", overflowX: "auto" }}
      className="custonScrollBar"
    >
      <table className="validtion-check-table">
        <thead className="table-head">
          <tr>
            <th style={{ textWrap: "nowrap" }}>Module ID</th>
            <th style={{ textWrap: "nowrap" }}>Element Type</th>
            <th style={{ textWrap: "nowrap" }}>Attribute</th>
            <th style={{ textWrap: "nowrap" }}>Element ID</th>
            <th>Content</th>
          </tr>
        </thead>
        <tbody>
          {data
            ?.filter((row) => row.mustUse && row.mlrStatus !== "Expired")
            .map((row, index) => (
              <tr key={index} className={index % 2 === 1 ? "odd-row" : ""}>
                <td style={{ textWrap: "nowrap" }}>
                  <div className="module-id-container">
                    <CheckCircleIcon
                      style={{
                        color: "green",
                        fontSize: "16px",
                      }}
                    />
                    {row.moduleId}
                  </div>
                </td>
                <td>{row.elementType}</td>
                <td style={{ textWrap: "nowrap" }}>{row.attribute}</td>
                <td style={{ textWrap: "nowrap" }}>
                  <div className="module-id-container">
                    <CheckCircleIcon
                      style={{
                        color: "green",
                        fontSize: "16px",
                      }}
                    />
                    {row.elementId}
                  </div>
                </td>
                <td>
                  {row.image ? (
                    <img
                      src={row.content}
                      alt="component"
                      className="component-image"
                    />
                  ) : (
                    row.content
                  )}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};
export default RunValidationCheckTable;
